import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';

const GreaseModal = ({
  title,
  visible,
  onOk,
  onCancel,
  maskClosable /*	Whether to close the modal dialog when the mask (area outside the modal) is clicked */,
  children,
  loading,
  showCancelButton,
  cancelText,
  afterClose,
  width,
  closable
}) => {

  let footer = [
    <Button
      key="submit"
      type="primary"
      loading={loading}
      onClick={onOk}
    >
      Close
    </Button>,
  ];
  if (showCancelButton) {
    footer = [
      <Button key="back" onClick={onCancel} loading={loading}>
        {cancelText || 'Cancel'}
      </Button>,
      ...footer,
    ];
  }

  const props = {
    title,
    visible,
    onOk,
    onCancel,
    footer,
    maskClosable,
    afterClose,
    width,
    closable
  };

  return <Modal {...props}>{children}</Modal>;
};

GreaseModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  visible: PropTypes.bool,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  cancelText: PropTypes.string,
  width: PropTypes.number.isRequired,
  okText: PropTypes.string,
  showCancelButton: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  maskClosable: PropTypes.bool,
  isOkEnableAfterCountdown: PropTypes.bool,
  afterClose: PropTypes.func,
  closable: PropTypes.bool
};

GreaseModal.defaultProps = {
  title: '',
  visible: false,
  onOk: () => {},
  onCancel: () => {},
  cancelText: 'Cancel',
  okText: 'OK',
  showCancelButton: true,
  loading: false,
  children: <></>,
  maskClosable: true,
  isOkEnableAfterCountdown: false,
  afterClose: () => {},
};

export default GreaseModal;
